module.exports = __webpack_public_path__ + "static/img/xiluocaiqieshucaichang.58f6084.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xiluocaiqieshucaichang.png
// module id = 04at
// module chunks = 1